var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button export-btn",class:{'is-loading-2':_vm.isExporting},attrs:{"data-track":"Export reviews link","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.exportReviews($event)}}},[_vm._v("\n  EXPORT REVIEWS")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c7e9a1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportReviews.vue
// module id = null
// module chunks = 